export function cn(...partes) {
    return partes.filter(Boolean).join(" ");
}
//# sourceMappingURL=cn.js.map